import { render, staticRenderFns } from "./purchase-input.vue?vue&type=template&id=fdd83400&scoped=true&"
import script from "./purchase-input.vue?vue&type=script&lang=js&"
export * from "./purchase-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd83400",
  null
  
)

export default component.exports